import createStore from 'unistore'
import devtools from 'unistore/devtools'

import { getInitialParameters } from './parametersHelpers'

const createCustomStore = (props, initialState, mappers, settingsMapper) => {
    const configParams = getInitialParameters(initialState.config, props, mappers || {})

    let state = {
        ...initialState,
        config: configParams
    }

    if (settingsMapper)
        state = settingsMapper(state)

    const store = process.env.NODE_ENV === 'production' ?  createStore(state) : devtools(createStore(state))
    return store
}

export { createCustomStore }
